export default {
    methods: {
        countNull(obj) {
            let result = 0;
            for (let i in obj) {
              if (obj[i] === null || obj[i] === ''||obj[i] === 0) {
              }else{
                result++
              }
            }
            return result;
          },

        count_unfinishedField(...args) {
            var temp ={}
            for (var a in args){
                Object.assign(temp, args[a]);
            }
          
            var lenghtOf= Object.keys(temp).length
            var objects=this.countNull(temp)
            return lenghtOf -objects
        },
        unsubscribeTokenToTopic(token, topic) {
          fetch('https://iid.googleapis.com/iid/v1/'+token+'/rel/topics/'+topic, {
            method: 'DELETE',
            headers: new Headers({
              'Authorization': 'key=AAAAOGhH_Js:APA91bH7ohkCXv5eR36gHJ393wuUoxIIJpYnmxf1Lqux_tXHnTBj4tgUyZJfBb01yAkFOFTcLwxCIpEGl4RMcBQMxmZnsHn8wI0JEc6-c5XIYTxwU81SfCLtV5vdg2oQBqephMCPQbxo'
            })
          }).then(response => {
            if (response.status < 200 || response.status >= 400) {
              throw 'Error subscribing to topic: '+response.status + ' - ' + response.text();
            }
            // console.log('unSubscribed from "'+topic+'"');
          }).catch(error => {
            console.error(error);
          })
        },
        subscribeTokenToTopic(token, topic) {
          fetch('https://iid.googleapis.com/iid/v1/'+token+'/rel/topics/'+topic, {
            method: 'POST',
            headers: new Headers({
              'Authorization': 'key=AAAAOGhH_Js:APA91bH7ohkCXv5eR36gHJ393wuUoxIIJpYnmxf1Lqux_tXHnTBj4tgUyZJfBb01yAkFOFTcLwxCIpEGl4RMcBQMxmZnsHn8wI0JEc6-c5XIYTxwU81SfCLtV5vdg2oQBqephMCPQbxo'
            })
          }).then(response => {
            if (response.status < 200 || response.status >= 400) {
              throw 'Error subscribing to topic: '+response.status + ' - ' + response.text();
            }
            // console.log('Subscribed to "'+topic+'"');
          }).catch(error => {
            console.error(error);
          })
        }
        
    }
};